export default __webpack_public_path__ + "static/media/breathing-badge.08f4a4d4.svg";